import React from 'react'

export default props => (
    <svg width="20" height="20" viewBox="0 0 24 24" {...props}>
        <g fill="none" fillRule="evenodd">
            <path
                d="M5.05 18.38a3.001 3.001 0 0 1 4.9 2.829l1.88 1.085a1 1 0 0 0 1.366-.366l8-13.856a1 1 0 0 0-.366-1.366L18.95 5.62a3.001 3.001 0 0 1-4.9-2.829l-1.88-1.085a1 1 0 0 0-1.366.366l-8 13.856a1 1 0 0 0 .366 1.366l1.88 1.086z"
                stroke={props.fill}
                strokeWidth="2"
            />
            <path fill={props.fill} d="M9.67 6.036l8.66 5-1 1.732-8.66-5z" />
        </g>
    </svg>
)
